import React, { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import TextEditor from "./TextEditor";
import Message from "./Message";
import axios from "axios";
import { logout } from "../actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import { notify } from "./notify";
import { AiOutlineSend } from "react-icons/ai";
import {
  MdFormatListBulleted,
  MdOutlineTransferWithinAStation,
} from "react-icons/md";
import { consult, transfer } from "../data/nurseForms";
import { FaRemoveFormat } from "react-icons/fa";

const VisitPhysicianNote = ({ visit }) => {
  const [editPhysicianNote, setEditPhysicianNote] = useState(false);

  const [physicianNote, setPhysicianNote] = useState(
    visit.physicianSection.physicianNote
      ? visit.physicianSection.physicianNote
      : "",
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const clinicDetails = useSelector((state) => state.clinicDetails);
  const { clinic } = clinicDetails;

  const dispatch = useDispatch();

  const updatePhysicianNote = async () => {
    // update physician note action
    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `/api/visits/${visit._id}/updateVisitPhysicianNote`,
        { physicianNote },
        config,
      );
      setPhysicianNote(data.updatedPhysicianNote);
      setLoading(false);
      setEditPhysicianNote(false);
      notify({
        title: "Physician Note Update",
        message: <p className="lead">Data updated successfully.</p>,
        type: "success",
        duration: 4000,
      });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setError(message);
      setLoading(false);
    }
  };

  const handleClear = () => {
    if (window.confirm("You will delete all text. Are you sure?")) {
      setPhysicianNote("");
    }
  };

  return (
    <div>
      {loading && <Skeleton height="120px" className="mb-5" />}
      {editPhysicianNote ? (
        <>
          <div className="text-dark w-100">
            <TextEditor text={physicianNote} setText={setPhysicianNote} />
          </div>
          <Row className="g-3 text-center text-primary my-2">
            <Col
              className="my-2"
              md={3}
              onClick={() => setPhysicianNote((prev) => prev + consult)}
            >
              <Card className="h-100 shadow-sm border border-primary">
                <Card.Body>
                  <Card.Text>
                    <MdFormatListBulleted /> Add Consultation Form{" "}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col
              className="my-2"
              md={3}
              onClick={() => setPhysicianNote((prev) => prev + transfer)}
            >
              <Card className="h-100 shadow-sm border border-primary ">
                <Card.Body>
                  <Card.Text>
                    <MdOutlineTransferWithinAStation /> Add Transfer Form{" "}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col className="my-2" md={3} onClick={handleClear}>
              <Card className="h-100 shadow-sm border border-danger text-danger">
                <Card.Body>
                  <Card.Text>
                    <FaRemoveFormat /> Clear{" "}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Message variant="danger" children={error} />

          <Row className="width-100 justify-content-end my-2">
            <Col className="mr-2 col-auto">
              <Button
                variant="outline-success"
                onClick={() => updatePhysicianNote()}
              >
                <AiOutlineSend /> Update Note
              </Button>
            </Col>
          </Row>
        </>
      ) : (
        <>
          {!physicianNote ? (
            <Message
              children={`No recorded details by physician`}
              variant={`info`}
            />
          ) : (
            <>
              <Row className="px-3">
                <div
                  className="text-primary text-center"
                  dangerouslySetInnerHTML={{
                    __html: physicianNote,
                  }}
                />
              </Row>
            </>
          )}
          <Row className="text-right width-100">
            <Col className="mr-2">
              <Button
                variant="outline-primary"
                onClick={() => setEditPhysicianNote(true)}
              >
                <FaEdit /> Edit Physician Notes
              </Button>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default VisitPhysicianNote;
